import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';
import { User } from '../users';

export interface NeedsValidationTimeData {
    needSubmitValidationTimeStamp: string;
    needSubmitValidationUserId: User;
    _id: string;
}

export interface NeedsValidationTimeResponse {
    message: string;
    data: NeedsValidationTimeData[];
}

export interface NeedsValidationTimeParams {
    startDate: string;
    endDate: string;
}

export const getNeedsValidationTime = async (params: NeedsValidationTimeParams): Promise<NeedsValidationTimeResponse> => {
    try {
        const response: AxiosResponse<NeedsValidationTimeResponse> = await apiClient.get(
            `/reporting/needs-validationtime/${params.startDate}/${params.endDate}`
        );
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
